import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Cluster } from 'ol/source';
import { Style, Icon, Fill, Text } from 'ol/style.js';

import { ToFeatures } from 'services/GeoJsonService';

export default class LayerFacilityCctvOverview extends VectorLayer {
    constructor(map) {
        const clusterStyle = feature => {
            const features = feature.get('features');
            const size = features.length;

            if (size > 1) {
                return [
                    new Style({
                        image: new Icon({
                            anchor: [0.5, 0.5],
                            anchorXUnits: 'fraction',
                            anchorYUnits: 'fraction',
                            src: '/images/facility/clust_cctv_bg.svg',
                        }),
                        zIndex: 3,
                    }),
                    new Style({
                        text: new Text({
                            font: 'bold 32px Pretendard, sans-serif',
                            text: size.toString(),
                            textBaseline: 'middle',
                            textAlign: 'center',
                            fill: new Fill({
                                color: '#333',
                            }),
                        }),
                        zIndex: 3,
                    }),
                ];
            }

            const properties = features[0].getProperties()?.properties;
            const isAccess = properties.type === 'accessCctv';

            const stat = isAccess && properties.hasAccessCctvError
                ? 0
                : properties.stat;

            return new Style({
                image: new Icon({
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    src: isAccess
                        ? (
                            stat == 1
                                ? '/images/facility/access_cctv_active.png'
                                : '/images/facility/access_cctv_inactive.png'
                        )
                        : (
                            stat == 1
                                ? '/images/facility/cctv_active.png'
                                : '/images/facility/cctv_inactive.png'
                        ),
                }),
                zIndex: isAccess ? 2 : 1,
            });
        };

        super({
            name: 'cctvOverviewLayer',
            source: new Cluster({
                distance: 120,
                minDistance: 80,
                source: new VectorSource(),
            }),
            visible: false,
            style: clusterStyle,
            userLayer: true,
            layerIndex: 0,
        });

        this.datasets = {
            cctv: [],
            accessCctv: [],
        };

        this.map = map;
        this.map?.addLayer(this);
    }

    setDataset = (type, dataset) => {
        this.datasets[type] = dataset;

        const combinedDataset = [
            ...this.datasets.cctv,
            ...this.datasets.accessCctv,
        ];

        let source = this.getSource();

        if (source instanceof Cluster) {
            source = source.getSource();
        }

        if (source instanceof VectorSource) {
            source.clear();
            source.addFeatures(ToFeatures(combinedDataset));
        }
    };
}